export const identity = {
  identityVerification: `Identity Verification`,
  requiredText: `Pursuant to Section 326 of the USA PATRIOT Act, we are required by law to collect detailed information to verify your identity.`,
  individualInvestor: `Individual Investor`,
  jointInvestor: `Joint Investor`,
  encryptionCopy: `We use 256-bit SSL encryption to protect your privacy`,
}
